import { Directive, ElementRef, EventEmitter, Output, OnDestroy, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appMarkAsRead]',
  standalone: true
})
export class MarkAsReadDirective implements AfterViewInit, OnDestroy {
  @Output() visible = new EventEmitter<void>();

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Emitir un evento cuando el elemento es visible
          this.visible.emit();
          // Desconectar el observer ya que solo se necesita marcarlo una vez
          this.observer.disconnect();
        }
      });
    }, {
      threshold: 0.8 // Ajusta este valor según cuánta parte del elemento debe ser visible para considerarlo "leído"
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
